import React from "react";
import type { ApolloClient } from "@apollo/client";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { Card } from "react-bootstrap";

import IconSpinner from "components/IconSpinner";
import { getContributionAbilityRequest } from "services/adminService";
import InfoTable from "components/InfoTable";
import type { AdminGetContributionAbilityQuery } from "types/graphql";

/** Non-null payload of the getContributionAbility query (has `history`). */
type ContributionAbilityData = NonNullable<
  AdminGetContributionAbilityQuery["getContributionAbility"]
>;

interface OwnProps {
  userId?: string;
  // declared in original propTypes but never invoked in this file
  push?: (...args: unknown[]) => void;
}

type Props = WithApolloClient<OwnProps>;

interface State {
  // initialized to {}; setState stores the raw query payload, which can be
  // null (preserved as-is) — Partial covers the empty-object init shape
  contributionAbility: Partial<ContributionAbilityData> | null;
  isFetching: boolean;
}

class ContributionAbility extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      contributionAbility: {},
      isFetching: true,
    };
  }

  async componentDidMount() {
    void getContributionAbilityRequest(
      this.props.client as ApolloClient<object>,
      // userId is an optional prop (PropTypes.string in original JS); the JS
      // passed it through unguarded. Assert non-null at the boundary to match
      // the service's `ID!` variable type — compile-time only, behavior unchanged.
      this.props.userId!
    ).then((contributionAbility) => {
      return this.setState({ isFetching: false, contributionAbility });
    });
  }

  _getTableMetadata = () => {
    return [
      {
        key: "totalContributionAmount",
        label: "Total Contribution Amount",
      },
      {
        key: "limit",
        label: "Contribution Limit",
      },
      {
        key: "amountRemaining",
        label: "Amount Remaining",
      },
    ];
  };

  _buildContributionYearTables = () => {
    // found-not-fixed: setState may store a null query payload; reading
    // `.history` on null throws at runtime. Original code did this unguarded.
    // @ts-expect-error contributionAbility is possibly null (preserved as-is)
    const history = this.state.contributionAbility.history || [];

    return history.map((ability) => {
      return (
        <React.Fragment key={ability.taxYear}>
          <h1 className="page-title">Tax Year {ability.taxYear}</h1>
          <InfoTable metadata={this._getTableMetadata()} data={ability} />
          <br />
        </React.Fragment>
      );
    });
  };

  render() {
    if (this.state.isFetching) {
      return <IconSpinner centered />;
    }

    return <Card.Body>{this._buildContributionYearTables()}</Card.Body>;
  }
}

export default withApollo<Props>(ContributionAbility);
